<div class="dashboard-container">
    <!-- Header Section -->
    <!-- <div class="dashboard-header">
    <div class="header-content">
      <h1 class="dashboard-title">Uptime Dashboard</h1>
      <p class="dashboard-subtitle">System monitoring and performance metrics</p>
    </div>
    <div class="header-controls">
      <div class="month-selector">
        <select class="month-select">
          <option>{{ currentMonth }}</option>
        </select>
      </div>
      <button class="refresh-btn">Refresh</button>
    </div>
  </div> -->

    <!-- Date Range -->
    <!-- <div class="date-range">
    {{ dateRange }}
  </div> -->

    <!-- Tabs -->
    <!-- <div class="tabs-container">
    <div class="tab active">Applications</div>
    <div class="tab">Servers</div>
  </div> -->

    <!-- Service Cards Grid -->
    <!-- <div class="services-grid">
    <div 
      class="service-card" 
      *ngFor="let service of services"
      [style.--service-color]="service.color"
    >
      <div class="service-header">
        <div class="service-icon" [style.background-color]="service.color">
          <span class="service-initial">{{ service.name.charAt(0) }}</span>
        </div>
        <div class="service-info">
          <h3 class="service-name">{{ service.name }}</h3>
          <p class="service-description">{{ service.description }}</p>
        </div>
      </div>
      
      <div class="gauges-container">
        <div 
          class="gauge-placeholder" 
          *ngFor="let gauge of service.gauges"
        >
          <div class="gauge-circle">
            <div class="gauge-inner">
              <span class="gauge-value">{{ gauge.value }}%</span>
            </div>
          </div>
          <p class="gauge-label">{{ gauge.label }}</p>
        </div>
      </div>
    </div>
  </div> -->

    <!-- Charts Section -->
    <div class="buttons-container m-2">
      @if(selected_filter=='day'){
        <button mat-raised-button color="primary" (click)="changeFilter('day')">Day</button>
      }@else {
        <button mat-stroked-button color="primary" (click)="changeFilter('day')">Day</button>
      }
      @if(selected_filter=='week'){
        <button mat-raised-button color="primary" (click)="changeFilter('week')">Week</button>
      }@else {
        <button mat-stroked-button color="primary" (click)="changeFilter('week')">Week</button>
      }
      @if(selected_filter=='month'){
        <button mat-raised-button color="primary" (click)="changeFilter('month')">Month</button>
      }@else {
        <button mat-stroked-button color="primary" (click)="changeFilter('month')">Month</button>
      }
      @if(selected_filter=='curr'){
        <button mat-raised-button color="primary" (click)="changeFilter('curr')">Current Month</button>
      }@else {
        <button mat-stroked-button color="primary" (click)="changeFilter('curr')">Current Month</button>
      }
    </div>
    @if (type=='application') {
    <div class="charts-section">
        <div class="chart-container">
            <uptime-charts [series]="chartSeries" [name]="'MQTT'" class="chart-component">
            </uptime-charts>
        </div>

        <div class="chart-container">
            <uptime-charts [series]="iotChartSeries" [name]="'IOT'" class="chart-component">
            </uptime-charts>
        </div>

        <div class="chart-container">
            <uptime-charts [series]="kurtosisChartSeries" [name]="'KURTOSIS'" class="chart-component">
            </uptime-charts>
        </div>
    </div>
    }@else {
    <div class="charts-section">
        <div class="chart-container">
            <uptime-charts [series]="dbChartSeries" [name]="'Database'" class="chart-component">
            </uptime-charts>
        </div>
        <div class="chart-container">
            <uptime-charts [series]="serviceChartSeries" [name]="'Servers'" class="chart-component">
            </uptime-charts>
        </div>
    </div>
    }
</div>